import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse } from 'types';

import { api } from 'utils';

const useApproveLDTransaction = (): UseMutationResult<
  [],
  ErrorResponse,
  { id: string }
> => {
  return useMutation(({ id }) =>
    api.put(`${url.approveLDTransaction}/${id}/approve`)
  );
};
export default useApproveLDTransaction;
